import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

export const TimerText = styled.p`
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-medium);
  color: var(--color-primary-110);
`
  
function formatDate(timeToEnd) {
    const day = Math.floor(timeToEnd / (1000 * 60 * 60 * 24))

    const hour = Math.floor((timeToEnd / (1000 * 60 * 60)) % 24)
    const minute = Math.floor((timeToEnd / 1000 / 60) % 60)
    const second = Math.floor((timeToEnd / 1000) % 60)

    if (day < 0) {
        return {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
        }
    }

    return {
        day,
        hour,
        minute,
        second,
    }
}

function formatNumber(n) {
    return `${n}`.length === 1 ? `0${n}` : `${n}`
}

export function Timer(props) {
    const { dateToEnd, setTimeToEnd } = props
    const [timeDiff, setTimeDiff] = useState(dateToEnd.getTime() - Date.now())
    const { day, hour, minute, second } = formatDate(timeDiff)

    useEffect(() => {
        const intervalId = window.setInterval(() => {
        const difference = dateToEnd.getTime() - Date.now()
        setTimeDiff(difference)
        setTimeToEnd(difference)
        }, 1000)

        if (timeDiff && timeDiff <= 0) {
        clearInterval(intervalId)
        setTimeToEnd(0)
        }
        return () => clearInterval(intervalId)
    }, [timeDiff])

    return (
        <TimerText data-testid="Timer">
        {!!(day && day > 0) && <span data-testid="DayElement">{formatNumber(day)}d </span>}
        <span data-testid="HourElement">{formatNumber(hour)}hr </span>
        <span data-testid="MinuteElement">{formatNumber(minute)}min </span>
        <span data-testid="SecondElement">{formatNumber(second)}seg</span>
        </TimerText>
    )
}